import { user_role } from "../../Config/Config";
import Api from "../../utils/axios";

const AuthApi = {
  // login: (payload) => Api.post(`auth/login/${user_role.admin}`, payload),
  login: (payload,roleId=1) => Api.post(`auth/login/${roleId}`, payload),
  checkEmail: (payload) => Api.post(`auth/check-email`, payload),
  register: (payload) => Api.post(`auth/register`, payload),
  currentUser: () => Api.get(`auth/current-user`),
  generateAccessToken: (payload) => Api.post("auth/refresh-token", payload),
  logoutUser: () => Api.post("auth/logout"),
  // getAllModifierCategory: () => apiService.get('modifierCategory')
  getRoles: () => Api.get(`master/get-active-role`),
};

export default AuthApi;
